import { FormAddressField } from 'components/ui/controlled-form/FormAddressField/index.js';
import { FormDatePicker } from 'components/ui/controlled-form/FormDatePicker/index.js';
import dayjs from 'dayjs';
import type { Control } from 'react-hook-form';

import { IssueFormRow } from '../components/IssueFormRow.js';
import { IssueFormYesNo } from '../components/IssueFormYesNo.js';

type Props = {
  control: Control<any>;
  isBlended: boolean | undefined;
  shouldValidate: boolean;
};

export const IssueFormBlending = ({ control, isBlended, shouldValidate }: Props) => {
  return (
    <>
      <IssueFormRow control={control} field="blending.isBlended">
        {props => (<IssueFormYesNo {...props} />)}
      </IssueFormRow>
      {isBlended === true && (
        <>
          <IssueFormRow control={control} field="blending.blendingDate">
            {props => (
              <FormDatePicker
                control={props.control}
                field={{ ...props.field, componentProps: { disableFuture: shouldValidate ? true : false } }}
                transform={{
                  onChange: dayjs => dayjs.format('YYYY-MM-DD'),
                  value: value => (value === undefined ? value : dayjs(value)),
                }}
              />
            )}
          </IssueFormRow>
          <IssueFormRow control={control} field="blending.blendingLocation">
            {props => (<FormAddressField {...props} />)}
          </IssueFormRow>
        </>
      )}
    </>
  );
};
